import { useCallback, useState } from "react";
import { useNotify } from "react-admin";
import { candidateRequests } from "api/candidateApi";
import LoadingActionButton from "server/components/LoadingActionButton";
import { getFileFromUrl } from "server/components/DownloadFile";
import { settings } from "app";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { administrationRequests } from "api/administrationApi";
import dataProvider from "../../../server/dataProvider/index";

const PreviewExamResultsProtocolButton = ({ exam }) => {
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const downloadResultProtocol = useCallback(async () => {
    setLoading(true);
    const { data } = await dataProvider.getMany(administrationRequests.getExamsSelect(), { ids: [exam.examId] });
    const examName = data?.length > 0 ? data[0].name : "exam";
    const fileName = `${examName}_${exam.campaignExamId}_протокол_оценки`;

    await getFileFromUrl(
      `${settings.gatewayApi}/${candidateRequests.getCampaignExamResultsProtocol(exam.campaignExamId)}`,
      fileName,
      notify,
    );

    setLoading(false);
  }, [notify, exam]);

  if (!exam) {
    return null;
  }

  return (
    <LoadingActionButton
      label="Оценки протокол"
      icon={<ContentPasteIcon />}
      onClick={downloadResultProtocol}
      loading={loading}
    />
  );
};

export default PreviewExamResultsProtocolButton;
